<template>
    <v-container fluid>
      <v-card :disabled="!editMode">
        <v-card-text :disabled="!editMode">
              <v-layout :disabled="!editMode">
                <v-data-table 
                :headers="cargosAtraso?headersAtraso:headers"
                :items="listaCargos"
                v-model="selectedRow"
                :loading="loading"
                hide-default-footer
                >
                <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                    No hay datos
                    </v-alert>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-xs-left">{{ item.cargoDescripcion }}</td>
                    <td class="text-xs-left">{{ cargosAtraso?item.desde: item.tipoCalificacionPersonaDescripcion }}</td>
                    <td class="text-xs-left">{{ cargosAtraso?item.hasta: item.momentoAplicacionDescripcion }}</td>
                    <td class="text-xs-left">{{ item.valor }}</td>

                    <td class="justify-center layout px-2" >                
                      <v-icon v-if="editMode" small  @click="removeCargo(item)">clear</v-icon>
                    </td>
                  </tr>
                </template>
                </v-data-table>
            </v-layout>

            <v-layout>
                <v-flex xs4>
                    <v-autocomplete v-model="nuevoCargo.cargo" return-object :items="opcionesCargos" 
                          item-text="descripcion" label="Cargo" placeholder="Seleccione uno" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete v-model="nuevoCargo.tipoCalificacionPersona" return-object :items="calificacionesPersonas" v-if="!cargosAtraso"
                          item-text="descripcion" label="Aplica para:" placeholder="Seleccione" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete v-model="nuevoCargo.momentoAplicacion" return-object :items="momentosAplicacion" v-if="!cargosAtraso"
                          item-text="descripcion" label="Aplica en:" placeholder="Seleccione" :disabled="!editMode" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-flex>
            </v-layout>

            <v-layout v-if="cargosAtraso">
              <v-flex xs3 >
                  <v-text-field v-model="nuevoCargo.desde" label="Atraso Desde (días)" :disabled="!editMode" required></v-text-field>
              </v-flex>
              <v-flex xs3>
                    <v-text-field v-model="nuevoCargo.hasta" label="Atraso Hasta (días)" :disabled="!editMode"></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout >
              <v-flex xs5>
                <v-switch label="Prorrateado En Cuotas" v-if="!cargosAtraso"
                            v-model="nuevoCargo.esProrrateado"
                            :disabled="!editMode" >
                  <template v-slot:append>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                          <template>
                            <p>
                              Si está activado: Indica que el cargo se incluye en cada cuota del plan
                            </p>
                            <p>
                              Si NO está activado: el cargo se descuenta del monto a otorgar
                            </p>
                          </template>
                        </v-tooltip>
                    </template>
                </v-switch>                
              </v-flex>
              <v-flex xs5>
                <v-switch label="Incluido en Tasa" 
                            v-model="nuevoCargo.estaIncluidoEnTasa"
                            :disabled="!editMode" v-if="nuevoCargo.esProrrateado">
                  <template v-slot:append>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">info</v-icon>
                        </template>
                          <template>
                            <p>
                              Si está activado: El importe del cargo se resta del importe calculado de intereses de cada cuota
                            </p>
                            <p>
                              Si NO está activado: El importe del cargo se suma a los intereses en cada cuota
                            </p>
                          </template>
                        </v-tooltip>
                    </template>                            
                </v-switch>

              </v-flex>
            </v-layout>
              
            <v-layout>              
              <v-flex xs4>
                  <v-radio-group :disabled="!editMode" v-model="nuevoCargo.esMontoFijo">
                    <v-radio v-bind:value="false">
                      <div slot="label">Porcentaje</div>
                    </v-radio>
                    <v-radio v-bind:value="true">
                      <div slot="label">Monto Fijo</div>
                    </v-radio>
                  </v-radio-group>
              </v-flex>
              <v-flex xs3>
                  <v-text-field v-model="nuevoCargo.valor" label="Valor" :disabled="!editMode" required></v-text-field>
              </v-flex>
              <v-flex xs3>
                    <v-text-field v-model="nuevoCargo.minimo" label="Mínimo"  v-if ="!nuevoCargo.esMontoFijo" :disabled="!editMode"></v-text-field>
              </v-flex>
              <v-flex xs2>
                  <v-btn v-if="editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small absolute  @click="addCargo(nuevoCargo)" >
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>
                  <!-- <v-btn color="success" :disabled="!editMode" @click="verCanalesVenta">Ver Canales de Venta del Grupo</v-btn> -->
              </v-flex>
            </v-layout>

            <v-divider></v-divider>
              <template v-if="$store.state.debugModeOn">
                Debug Info: <p></p>  
                Nuevo Cargo: {{nuevoCargo}}  <p></p>                            
              </template>
              <v-divider></v-divider>
          </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: () => ({
    loading: false,
    pagination: { // definición de paginación
      descending: false,          
      page: 1,
      rowsPerPage: 5,
      sortBy: '',        
      rowsPerPageItems: [5, 10, 15, 20, 50]
    }, 
    totalItems: 0, // va afuera de pagination
    headers: [ // definición de columnas
      { text: 'Cargo', value: 'descripcion' },
      { text: 'Aplica Para', value: 'aplicaPara' },
      { text: 'Aplica En', value: 'aplicaEn' },
      { text: 'Valor', value: 'valor' }
    ],
    headersAtraso: [ // definición de columnas
      { text: 'Cargo', value: 'descripcion' },
      { text: 'Desde (días)', value: 'desde' },
      { text: 'Hasta (días)', value: 'hasta' },
      { text: 'Valor', value: 'valor' }
    ],
    listaCargos: [], // registros
    selectedRow: [],
    nuevoCargo:{cargo:{id:0}, tipoCalificacionPersona:{id:0}, momentoAplicacion:{id:0}, esMontoFijo:false, esPorcentaje:true, esProrrateado: false, estaIncluidoEnTasa: false, valor:0,minimo:0, desde:0, hasta:0},
    opcionesCargos:[],
    calificacionesPersonas:[],
    momentosAplicacion:[{id:1,descripcion:'Alta'},{id:2,descripcion:'Cobranza'}]
  }),
  props: {
    value: {
      type: Array,
      required: true
    },
    propName:{
        type: String,
        required: true,
        default: 'listaCargos'
    },
    label: {
      type: String,
      default: 'Lista Cargos'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    cargosAtraso: {
      type: Boolean,
      default: false
    }
  },
  watch:{
    'value': function(){
        this.setLista();
      },
      'nuevoCargo.esMontoFijo': function(){          
        this.nuevoCargo.esPorcentaje = !this.nuevoCargo.esMontoFijo;
    },
  },
  computed: {  
  },
  created () {
    this.loadTiposCalificacionPersona();
    this.loadCargos();          
  },
  methods: {
    ...mapMutations(['alertWarning']),
    ...mapActions(['']),
    setLista(){ 
      if(!this.value[this.propName]){
            this.listaCargos = []
            
            this.value[this.propName] = this.listaCargos
        }
        this.listaCargos = this.value;
    },
    async loadCargos() {
        this.loading = true
        try {
            var result = await http.get('cargos'); // traigo todas
            this.opcionesCargos = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
    },
    async loadTiposCalificacionPersona() {
        this.loading = true
        try {
            var result = await http.get('tiposcalificacionpersona');
            this.calificacionesPersonas = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
    },
    addCargo: function(newItem){
      if(!this.validarNuevoCargo(newItem)) return;

      this.listaCargos.push({cargoId:newItem.cargo.id, cargoDescripcion:newItem.cargo.descripcion,
                            tipoCalificacionPersonaId:newItem.tipoCalificacionPersona.id, tipoCalificacionPersonaDescripcion:newItem.tipoCalificacionPersona.descripcion,
                            momentoAplicacionId:newItem.momentoAplicacion.id, momentoAplicacionDescripcion:newItem.momentoAplicacion.descripcion,
                            esMontoFijo:newItem.esMontoFijo, esPorcentaje:newItem.esPorcentaje, valor:newItem.valor, desde:newItem.desde,hasta:newItem.hasta,
                            minimo:this.nuevoCargo.esPorcentaje ? newItem.minimo:null})

      this.nuevoCargo = {cargo:{id:newItem.cargo.id, descripcion:newItem.cargo.descripcion}, tipoCalificacionPersona:{id:0}, momentoAplicacion:{id:0}, esMontoFijo:false, esPorcentaje:true,valor:0,minimo:0, desde: parseInt(newItem.hasta) + 1, hasta:parseInt(newItem.hasta)+1};

    },
    removeCargo(item){
      var i = 0;
      for (i = 0; i < this.listaCargos.length; i++) { 
        if(this.listaCargos[i] == item){
            break;
        }
      }
      this.listaCargos.splice(i,1);
    },
    validarNuevoCargo(item){
      if(!item.cargo.id > 0){
        this.alertWarning('Debe elegir un cargo.');
        return false;
      }
      if(!this.cargosAtraso &&  !item.tipoCalificacionPersona.id > 0){
        this.alertWarning('Debe elegir un tipo de calificación de persona.');
        return false;
      }
      if(!this.cargosAtraso && !item.momentoAplicacion.id > 0){
        this.alertWarning('Debe elegir un momento de aplicación.');
        return false;
      }
      if(this.cargosAtraso && !item.desde >0){
        this.alertWarning('Debe definir la cantidad de día de atraso (desde).');
        return false;
      }
      
      if(this.cargosAtraso && !item.hasta >0){
        this.alertWarning('Debe definir la cantidad de día de atraso (hasta).');
        return false;
      }

      if(!item.valor >0){
        this.alertWarning('El valor debe ser mayor a 0.');
        return false;
      }
      
      if(!this.cargosAtraso)
        for (let i = 0; i < this.listaCargos.length; i++) { 
          // si alguno de los cargo coincide en todo no permito agregarlo
          if(this.listaCargos[i].cargoId == item.cargo.id && 
            this.listaCargos[i].momentoAplicacionId == item.momentoAplicacion.id && 
            this.listaCargos[i].tipoCalificacionPersonaId == item.tipoCalificacionPersona.id)
          {
              this.alertWarning('Un cargo de la lista coincide en momento y tipo de aplicación. Por favor verifique.');
              return false;
          }
        }

      return true;
    }
  },
  
  
}

</script>